(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["bunny-video-player"] && !Shopify.designMode) return;
  try {
    if (!customElements.get('bunny-video-playlist')) {
  customElements.define('bunny-video-playlist', class extends HTMLElement {
    connectedCallback() {
      this.controller?.abort();
      this.controller = new AbortController();
      this.addEventListener('click', (event) => {
        const button = event.target.closest('button[data-video-id]');
        if (!button || !this.contains(button)) return;
        const frame = this.querySelector('[data-main-player] iframe');
        if (!frame) return;
        this.querySelectorAll('button[data-video-id]').forEach((item) => {
          const active = item === button;
          item.classList.toggle('active', active);
          item.setAttribute('aria-pressed', String(active));
        });
        if (frame.dataset.videoId === button.dataset.videoId) return;
        const library = encodeURIComponent(this.dataset.libraryId.trim());
        const video = encodeURIComponent(button.dataset.videoId.trim());
        frame.title = button.dataset.videoTitle;
        frame.dataset.videoId = button.dataset.videoId;
        frame.src = `https://player.mediadelivery.net/embed/${library}/${video}?autoplay=false&loop=false&muted=false`;
      }, { signal: this.controller.signal });
    }
    disconnectedCallback() { this.controller?.abort(); }
  });
}
  } catch(e) { console.error(e); }
})();

})();
